<template>

    <div class="page-static-container">

        <header-static v-if="!isNativeUser"></header-static>

        <article class="page-static-text-container" v-html="html"></article>

        <footer-landing v-if="!isNativeUser"></footer-landing>

        <link rel="stylesheet" type="text/css" href="/static/css/style.css">

    </div>

</template>

<script>

import I18n from '@/modules/i18n'
import UserFlow from '@/modules/userFlow'

import HeaderStatic from '@/components/headers/HeaderStatic'
import FooterLanding from '@/components/FooterLanding'


export default {

    name: 'impressum',

    components: {HeaderStatic, FooterLanding},

    computed: {

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        }
    },

    data() {
        return {
            html: ''
        }
    },

    created() {
        UserFlow.setPage(this, 'impressum')
    },

    mounted() {

        this.$http.get(`/static/impressum/${I18n.get(this)}.html`).then(response => {
            this.html = response.data
        })

    }
}
</script>

<style scoped lang="scss"></style>
